import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { ParamContext } from '../../service/param.context';
import { map } from 'rxjs/operators';
import { PaginatedResponse } from '../../study/service/study-entry.service';
import { EnableLoadingIndicator } from '../../loading-indicator';

@Injectable({
    providedIn: 'root'
})
export class GermplasmStudySourceService {

    constructor(private http: HttpClient,
                private paramContext: ParamContext) {
    }

    searchGermplasmStudySources(studyId: number, germplasmStudySourceRequest: GermplasmStudySourceRequest, page: number, pageSize: number, sort: string) {
        let url = `/bmsapi/crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/studies/${studyId}/germplasm-sources/table` + ((page !== undefined && pageSize !== undefined) ? '?page=' + page + '&size=' + pageSize : '');
        url += (sort) ? '&sort=' + sort : '';
        return this.http.post<HttpResponse<GermplasmStudySourceModel[]>>(url, germplasmStudySourceRequest, { observe: 'response', context: new HttpContext().set(EnableLoadingIndicator, true) }).pipe(
            map(response => {
                return {
                    data: response.body || [],
                    filteredCount: Number(response.headers.get('X-Filtered-Count')),
                    totalCount: Number(response.headers.get('X-Total-Count')),
                    page: page,
                    size: pageSize
                } as PaginatedResponse<GermplasmStudySourceModel>;
            })
        );
    };

    saveSearchRequest(studyId: number, germplasmStudySourceRequest: GermplasmStudySourceRequest) {
        const url = `/bmsapi/crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/studies/${studyId}/germplasm-sources/search`;
        return this.http.post<any>(url, germplasmStudySourceRequest);
    };

}


export class GermplasmStudySourceRequest {
    constructor(
        public studyId: number,
        public filter: GermplasmStudySourceFilter
    ) {
    }
}

export class GermplasmStudySourceFilter {
    constructor(
        public germplasmStudySourceId: number,
        public gidList: number[],
        public groupIdList: number[],
        public designation: string,
        public cross: string,
        public numberOfLotsList: number[],
        public breedingMethodAbbreviation: string,
        public breedingMethodName: string,
        public breedingMethodType: string,
        public breedingLocationName: string,
        public trialInstanceList: string[],
        public plotNumberList: number[],
        public replicationNumberList: number[],
        public germplasmDateList: number[]
    ) {
    }
}

export class GermplasmStudySourceModel {
    constructor(
        public germplasmStudySourceId?: number,
        public gid?: number,
        public groupId?: number,
        public designation?: string,
        public cross?: string,
        public numberOfLots?: number,
        public breedingMethodAbbreviation?: string,
        public breedingMethodName?: string,
        public breedingMethodType?: string,
        public breedingLocationName?: string,
        public trialInstance?: string,
        public plotNumber?: number,
        public replicationNumber?: number,
        public germplasmDate?: number) {
    }

}

